export const generateColorFromString = (str: string): string => {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }

  const finalHash = (hash >>> 0) * 2654435761;
  const hue = finalHash % 360;

  return `hsl(${hue}, 70%, 50%)`;
};
